import axios from "axios";
import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { logout, reset } from "../../../features/auth/authSlice";
import tikgImage from "../../../images/singleinvoice/tick-green.svg";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";
import { setNotification } from "../../../features/notification/notificationSlice.js";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { useApproveTimeOffRequest, useCancelTimeOffRequest, useRejectTimeOffRequest } from "../../../components/TimeOff/timeOffApi.jsx";

const SUPER_ADMIN = 1;
const ADMIN = 2;
const USER = 3;
const PROJECT_MANAGER = 6;
const TEAM_MANAGER = 7;

const ManageTimeOff = ({ user, timeOffData, setTimeOffData, token }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

    const approveTimeOffRequestMutation = useApproveTimeOffRequest(token);
    const rejectTimeOffRequestMutation = useRejectTimeOffRequest(token);
    const cancelTimeOffRequestMutation = useCancelTimeOffRequest(token);

    const handleApprove = () => {
        setIsApproveModalOpen(true);
    };

    const handleConfirmApprove = async () => {
        try {
            setIsSubmitLoading(true);
            const response = await approveTimeOffRequestMutation.mutateAsync(timeOffData._id);

            if (response.data) {
                toast.success("Time Off request approved successfully!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request Approved successfully!`
                );
                dispatch(setNotification(Date.now()));
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Approved",
                }));
                setIsApproveModalOpen(false);
            }
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "mailfailed") {
                toast.error("TOR approved but something went wrong in sending mail!!", {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request Approved successfully but something went wrong in sending Mail!!!`
                );
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Approved",
                }));
                setIsApproveModalOpen(false);
            } else if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            } else {
                toast.error("Something went wrong in approval!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Something went wrong while Approving Time Off "${timeOffData._id}"!!!`
                );
                console.log(error);
            }
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelApprove = () => {
        setIsApproveModalOpen(false);
    };

    const handleReject = () => {
        setIsRejectModalOpen(true);
    };

    const handleConfirmReject = async () => {
        try {
            setIsSubmitLoading(true);
            await rejectTimeOffRequestMutation.mutateAsync(timeOffData._id);
            toast.success("Time-Off request rejected successfully!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "Time Off",
                `Time Off "${timeOffData._id}" request rejected successfully!`
            );
            dispatch(setNotification(Date.now()));
            setTimeOffData((prevState) => ({
                ...prevState,
                status: "Rejected",
            }));
            setIsRejectModalOpen(false);
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "mailfailed") {
                toast.error("TOR rejected but something went wrong in sending mail!!", {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request rejected successfully but Something went wrong in sending Mail!!!`
                );
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Rejected",
                }));
                setIsRejectModalOpen(false);
            } else if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            } else {
                toast.error("Something went wrong in TOR rejection!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Something went wrong while rejecting Time Off "${timeOffData._id}" request!!!`
                );
                console.log(error);
            }
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelReject = () => {
        setIsRejectModalOpen(false);
    };

    const handleCancel = () => {
        setIsCancelModalOpen(true);
    };

    const handleConfirmCancel = async () => {
        try {
            setIsSubmitLoading(true);
            await cancelTimeOffRequestMutation.mutateAsync(timeOffData._id);
            toast.success("Time-Off request cancelled successfully!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "Time Off",
                `Time Off "${timeOffData._id}" request cancelled successfully!`
            );
            dispatch(setNotification(Date.now()));
            setTimeOffData((prevState) => ({
                ...prevState,
                status: "Cancelled",
            }));
            setIsCancelModalOpen(false);
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "mailfailed") {
                toast.error("TOR cancelled but something went wrong in sending mail!!", {
                    position: "bottom-right",
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Time Off "${timeOffData._id}" request cancelled successfully but Something went wrong in sending Mail!!!`
                );
                setTimeOffData((prevState) => ({
                    ...prevState,
                    status: "Cancelled",
                }));
                setIsCancelModalOpen(false);
            } else if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: timeOffData,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            } else {
                toast.error("Something went wrong in TOR cancelation!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                global.config.activityLog(
                    window.location.href,
                    "Time Off",
                    `Something went wrong while Canceling Time Off "${timeOffData._id}" request!!!`
                );
                console.log(error);
            }
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelCancel = () => {
        setIsCancelModalOpen(false);
    };

    return (
        <div className="manage-detail-outer">
            <div className="manage-detail-bs2">
                <div className="invoice-manage-singlepg-head">Manage Time Off</div>
                <div className="single-invo-sattus">
                    <div className="invo-main-status-head">Request Status</div>
                    <div className="invo-sig-st-btns">
                        {(user &&
                            (user.userType === SUPER_ADMIN ||
                                user.userType === ADMIN ||
                                user.userType === TEAM_MANAGER)) &&
                            timeOffData?.status !== "Cancelled" && (
                                <>
                                    {timeOffData?.status === "Approved" ? (
                                        <Link className="Approve-singlebtn approved disable-cursor" >
                                            Approved <img src={tikgImage} alt="Edit Icon" />
                                        </Link>
                                    ) : (
                                        <Link
                                            className="Approve-singlebtn"
                                            onClick={handleApprove}
                                            disabled={isSubmitLoading}
                                        >
                                            Approve <img src={tikgImage} alt="Edit Icon" />
                                        </Link>
                                    )}
                                    <Modal
                                        className="delete-modal"
                                        isOpen={isApproveModalOpen}
                                        onRequestClose={
                                            !isSubmitLoading ? handleCancelApprove : undefined
                                        }
                                        contentLabel="Confirm Approve"
                                        style={{
                                            content: {
                                                height: "41%",
                                                width: "30%",
                                                position: "fixed",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-17.5%, 0%)",
                                                parent: document.querySelector(
                                                    ".admin-outer.time.tracker"
                                                ),
                                            },
                                        }}
                                    >
                                        <div className="delete-modal-content">
                                            <h2>Confirm Approve</h2>
                                            <p>
                                                Are you sure you want to Approve this Time Off
                                                Request?
                                            </p>
                                            {isSubmitLoading ? (
                                                <div className="outter-load-table">
                                                    <ThreeDots
                                                        height="28"
                                                        width="30"
                                                        radius="9"
                                                        color="#6479f9"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClassName=""
                                                        visible={true}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="delete-modal-buttons">
                                                    <button
                                                        className="buttons-approved"
                                                        onClick={handleConfirmApprove}
                                                        disabled={isSubmitLoading}
                                                    >
                                                        Approve
                                                    </button>
                                                    <button
                                                        onClick={handleCancelApprove}
                                                        disabled={isSubmitLoading}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </Modal>
                                    {timeOffData?.status === "Rejected" ? (
                                        <Link className="Reject-singlebtn rejected disable-cursor" >
                                            Rejected <img src={crssrImage} alt="Edit Icon" />
                                        </Link>
                                    ) : (
                                        <Link
                                            className="Reject-singlebtn"
                                            onClick={handleReject}
                                            disabled={isSubmitLoading}
                                        >
                                            Reject <img src={crssrImage} alt="Edit Icon" />
                                        </Link>
                                    )}
                                    <Modal
                                        className="delete-modal"
                                        isOpen={isRejectModalOpen}
                                        onRequestClose={
                                            !isSubmitLoading ? handleCancelReject : undefined
                                        }
                                        contentLabel="Confirm Reject"
                                        style={{
                                            content: {
                                                height: "41%",
                                                width: "30%",
                                                position: "fixed",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-17.5%, 0%)",
                                                parent: document.querySelector(
                                                    ".admin-outer.time.tracker"
                                                ),
                                            },
                                        }}
                                    >
                                        <div className="delete-modal-content">
                                            <h2>Confirm Reject</h2>
                                            <p>
                                                Are you sure you want to Reject this Time Off
                                                Request?
                                            </p>
                                            {isSubmitLoading ? (
                                                <div className="outter-load-table">
                                                    <ThreeDots
                                                        height="28"
                                                        width="30"
                                                        radius="9"
                                                        color="#6479f9"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClassName=""
                                                        visible={true}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="delete-modal-buttons">
                                                    <button
                                                        className="buttons-rejected"
                                                        onClick={handleConfirmReject}
                                                        disabled={isSubmitLoading}
                                                    >
                                                        Reject
                                                    </button>
                                                    <button
                                                        onClick={handleCancelReject}
                                                        disabled={isSubmitLoading}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </Modal>
                                </>
                            )}
                        {((user &&
                            (user.userType === SUPER_ADMIN ||
                                user.userType === ADMIN ||
                                user.userType === TEAM_MANAGER)) ||
                            (timeOffData?.start_date &&
                                moment.tz(timeOffData.start_date, global.config.getTimeZone()).isAfter(
                                    moment.tz(global.config.getTimeZone()),
                                    "day"
                                ))) && (
                                <>
                                    {timeOffData?.status === "Cancelled" ?
                                        (
                                            <Link className="Reject-singlebtn rejected disable-cursor" >
                                                Cancelled <img src={crssrImage} alt="Edit Icon" />
                                            </Link>
                                        ) :
                                        (
                                            <Link
                                                className="Reject-singlebtn"
                                                onClick={handleCancel}
                                                disabled={isSubmitLoading}
                                            >
                                                Cancel <img src={crssrImage} alt="Edit Icon" />
                                            </Link>
                                        )}
                                    <Modal
                                        className="delete-modal"
                                        isOpen={isCancelModalOpen}
                                        onRequestClose={
                                            !isSubmitLoading ? handleCancelCancel : undefined
                                        }
                                        contentLabel="Confirm Cancel"
                                        style={{
                                            content: {
                                                height: "41%",
                                                width: "30%",
                                                position: "fixed",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-17.5%, 0%)",
                                                parent: document.querySelector(
                                                    ".admin-outer.time.tracker"
                                                ),
                                            },
                                        }}
                                    >
                                        <div className="delete-modal-content">
                                            <h2>Confirm Cancel</h2>
                                            <p>
                                                Are you sure you want to Cancel this Time Off
                                                Request?
                                            </p>
                                            {isSubmitLoading ? (
                                                <div className="outter-load-table">
                                                    <ThreeDots
                                                        height="28"
                                                        width="30"
                                                        radius="9"
                                                        color="#6479f9"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClassName=""
                                                        visible={true}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="delete-modal-buttons">
                                                    <button
                                                        className="buttons-rejected"
                                                        onClick={handleConfirmCancel}
                                                        disabled={isSubmitLoading}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={handleCancelCancel}
                                                        disabled={isSubmitLoading}
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </Modal>

                                </>
                            )}
                        {user &&
                            !(user.userType === SUPER_ADMIN ||
                                user.userType === ADMIN ||
                                user.userType === TEAM_MANAGER) && (timeOffData?.status !== "Cancelled") && (
                                <Link
                                    className={`${timeOffData?.status === "Approved"
                                        ? "Approve-singlebtn approved disable-cursor"
                                        : timeOffData?.status === "Rejected" || timeOffData?.status === "Cancelled"
                                            ? "Reject-singlebtn rejected disable-cursor"
                                            : "Reject-singlebtn disable-cursor" // Default case (e.g., "Pending")
                                        }`}
                                >
                                    {timeOffData?.status === "Approved" && (
                                        <>
                                            Approved <img src={tikgImage} alt="Approved Icon" />
                                        </>
                                    )}
                                    {(timeOffData?.status === "Rejected" || timeOffData?.status === "Cancelled") && (
                                        <>
                                            {timeOffData?.status} <img src={crssrImage} alt="Rejected/Cancelled Icon" />
                                        </>
                                    )}
                                    {!(timeOffData?.status === "Approved" || timeOffData?.status === "Rejected" || timeOffData?.status === "Cancelled") && (
                                        <>
                                            {timeOffData?.status || "Pending"} <img src={crssrImage} alt="Pending Icon" />
                                        </>
                                    )}
                                </Link>
                            )}
                    </div>
                </div>
                {(user?.userType === SUPER_ADMIN || user?.userType === ADMIN) && timeOffData?.tor_verified_by && (
                    <div className="single-invo-sattus">
                        <div className="invo-main-status-head">Reviewed By</div>
                        <div className="company-detail">
                            <div className="companynae-sig">
                                {timeOffData.tor_verified_by?.first_name ? (
                                    <>
                                        {timeOffData.tor_verified_by.first_name}{' '}
                                        {timeOffData.tor_verified_by.middle_name && timeOffData.tor_verified_by.middle_name !== 'null' ? timeOffData.tor_verified_by.middle_name + ' ' : ''}
                                        {timeOffData.tor_verified_by.last_name}{' '}
                                    </>
                                ) : (
                                    <>
                                        {timeOffData.tor_verified_by?.company_first_name
                                            ? `${timeOffData.tor_verified_by.company_first_name} ${timeOffData.tor_verified_by.company_last_name ? timeOffData.tor_verified_by.company_last_name : ''}`
                                            : `${timeOffData.tor_verified_by.company_name || ''}(Company)`}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ManageTimeOff;